import cn from "classnames";
import { InputCheckbox } from "src/components/ui-components/Input/InputCheckbox";
import * as Menu from "src/components/ui-components/MenuPanel/MenuPanel";
import styles from "./CheckList.module.css";
import { CheckListItem, CheckListItems, TOTAL_STEPS } from "./content";
import { ButtonTextOnly } from "../ui-components/ButtonTextOnly/ButtonTextOnly";
import { IconChevronUp } from "../ui-components/Icons/IconChevronUp";
import Link from "next/link";
import { useTrackDismissedAt } from "src/gql/creatorOnboardingChecklist/trackDismissedAt";
import { useSession } from "src/components/session/session";
import { useEffect } from "react";
import AmplitudeService from "src/services/amplitude";

interface CheckedItems {
  [key: string]: {
    completed: boolean;
    withDetails: boolean;
  };
}

export function CheckList({
  checklist,
  checklistItemsState,
  stepsCompleted,
  onHide,
}: {
  checklist: CheckListItems;
  checklistItemsState: CheckedItems;
  stepsCompleted: number;
  onHide: () => void;
}) {
  const hasCompletedAllSteps = stepsCompleted === TOTAL_STEPS;
  const session = useSession();
  const [trackDismissedAt] = useTrackDismissedAt(session);

  const onCloseChecklist = () => {
    if (hasCompletedAllSteps) {
      trackDismissedAt();
    }
    onHide();
  };
  useEffect(() => {
    AmplitudeService.trackEvent("Creator Onboarding Checklist Viewed");
  }, []);

  return (
    <Menu.Panel className={styles.menu}>
      <Menu.Section>
        <div className={styles.menuTitle}>
          <div>
            {!hasCompletedAllSteps &&
              `Step ${stepsCompleted + 1} of ${TOTAL_STEPS}`}
          </div>
          <ButtonTextOnly theme="primary" size="M" onClick={onCloseChecklist}>
            {hasCompletedAllSteps ? `Close Forever` : `Hide`}
            <IconChevronUp />
          </ButtonTextOnly>
        </div>
        {checklist.items.map((item) => (
          <CheckListEntry
            key={item.key}
            completed={checklistItemsState[item.key].completed}
            withDetails={checklistItemsState[item.key].withDetails}
            item={item}
          />
        ))}

        {hasCompletedAllSteps && (
          <div className={styles.lastHint}>
            Great work! Stay curious and
            <br />
            keep learning with Dune's
            <br />
            <Link
              href="https://dune.com/docs/learning/#dune-101"
              target="_blank"
            >
              learning resources
            </Link>{" "}
            docs.
          </div>
        )}
      </Menu.Section>
    </Menu.Panel>
  );
}

function CheckListEntry({
  completed,
  withDetails,
  item,
}: {
  completed: boolean;
  withDetails: boolean;
  item: CheckListItem;
}) {
  return (
    <Menu.ItemButton style={{ background: "none" }}>
      <InputCheckbox
        checked={completed}
        onChange={() => {}}
        className={cn(completed ? styles.greenCheckbox : styles.checkbox)}
        hint={!completed && withDetails && item.description}
      >
        <div className={cn(completed ? styles.strikethrough : styles.title)}>
          {item.title}
        </div>
      </InputCheckbox>
    </Menu.ItemButton>
  );
}
